import { render, staticRenderFns } from "./CatalogsList.vue?vue&type=template&id=d116ef8c&scoped=true&"
import script from "./CatalogsList.vue?vue&type=script&lang=js&"
export * from "./CatalogsList.vue?vue&type=script&lang=js&"
import style0 from "./CatalogsList.vue?vue&type=style&index=0&id=d116ef8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d116ef8c",
  null
  
)

export default component.exports